import { useNavigate } from "react-router-dom";
import "./Css/TeaccherForm.css";
import { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const AddStudent = () => {
  const navigate = useNavigate();

  // Form state
  const [studentName, setStudentName] = useState("");
  const [email, setEmail] = useState("");
  const [parentPhoneNumber, setParentPhoneNumber] = useState("");
  const [standardId, setStandardId] = useState(""); // number
  const [softwareIds, setSoftwareIds] = useState([]); // array of selected software ids
  const [address, setAddress] = useState("");
  const [softwares, setSoftwares] = useState([]);
  const [birthDate, setBirthDate] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [fatherName, setFatherName] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [createdStudent, setCreatedStudent] = useState(null); // store returned data
const [standards, setStandards] = useState([]);
useEffect(() => {
  if (!standardId) {
    setSoftwares([]);
    setSoftwareIds([]);
    return;
  }

  const fetchSoftwares = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API_BASE}/api/instituteadmin/students/softwares?standardId=${standardId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Softwares API response:", res.data);
      setSoftwares(res.data);

    } catch (error) {
      console.error("Error fetching softwares", error.response?.data);
    }
  };

  fetchSoftwares();
}, [standardId]);

useEffect(() => {
  const fetchStandards = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${API_BASE}/api/instituteadmin/students/standards`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStandards(res.data);
    } catch (error) {
      console.error("Error fetching standards", error.response?.data);
    }
  };

  fetchStandards();
}, []);

  const handleSubmit = async () => {
  try {
    if (!studentName || !email || !parentPhoneNumber || !standardId) {
      alert("Please fill all required fields");
      return;
    }

    if (softwareIds.length === 0) {
      alert("Please select at least one software");
      return;
    }

    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("StudentName", studentName);
    formData.append("Email", email);
    formData.append("ParentPhoneNumber", parentPhoneNumber);
    formData.append("StandardId", Number(standardId));
    formData.append("Address", address);
    formData.append("IsActive", "true");
    formData.append("FatherName", fatherName);

    if (birthDate) {
      formData.append("BirthDate", birthDate);
    }

    softwareIds.forEach(id => {
      formData.append("SoftwareIds", id);
    });

    if (profilePicture) {
      formData.append("ProfilePicture", profilePicture);
    }

  const res = await axios.post(
  `${API_BASE}/api/instituteadmin/students`,
  formData,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);

console.log("Created student:", res.data);

// 🔥 important
setCreatedStudent(res.data);
setShowPopup(true);


    console.log(res.data);
    setShowPopup(true);

  } catch (err) {
    console.error(err.response?.data);
    alert(err.response?.data);
  }
  
};
  return (
    <div className="student-page">
      {/* Top bar */}
      <div className="top-bar">
        <span className="breadcrumb">
          <span
            className="breadcrumb-link"
            onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}
          >
            विद्यार्थी व्यवस्थापन
          </span>
          &nbsp;&gt;&gt;&nbsp;
          <b>नवीन विद्यार्थी जोडा</b>
        </span>
        <div className="top-buttons">
          <button
            className="btn outline"
            onClick={() => navigate(-1)}
          >
            रद्द करा
          </button>

         <button
  className="btn primary"
  onClick={handleSubmit} // ✅ call the API
>
  सेव्ह करा
</button>
  </div>
      </div>

      {/* Form Card */}
      <div className="form-card">
        <h2>नवीन विद्यार्थी जोडा</h2>

        <form className="student-form">
          <div className="form-group">
            <label>विद्यार्थी नाव</label>
            <input
              type="text"
              placeholder="विद्यार्थी नाव इथे टाका"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>इयत्ता</label>
        <select
  value={standardId}
  onChange={(e) => setStandardId(e.target.value)}
>
  <option value="">इयत्ता निवडा</option>
  {standards.map((std) => (
    <option key={std.id} value={std.id}>
      {std.name}
    </option>
  ))}
</select>
          </div>

          <div className="form-group">
            <label>पालकांचा दूरध्वनी क्रमांक</label>
             <input
              type="text"
              placeholder="पालकांचा दूरध्वनी क्रमांक इथे टाका"
              value={parentPhoneNumber}
              onChange={(e) => setParentPhoneNumber(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>पत्ता</label>
             <input
              type="text"
              placeholder="पत्ता इथे टाका"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>ईमेल</label>
             <input
              type="email"
              placeholder="ईमेल इथे टाका"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>जन्मतारीख</label>
           <input
              type="date"
              value={birthDate}
              onChange={(e) => setBirthDate(e.target.value)}
            />
          </div>

       <div className="form-group">
  <label>पालकांचे नाव</label>
  <input
    type="text"
    placeholder="पालकांचे नाव इथे टाका"
    value={fatherName}
    onChange={(e) => setFatherName(e.target.value)}
  />
</div>

<div className="form-group">
  <label>परीक्षेचे नाव</label>
  <select
    value={softwareIds[0] || ""}
    onChange={(e) => setSoftwareIds([Number(e.target.value)])}
  >
    <option value="">परीक्षा निवडा</option>
    {softwares.map(sw => (
      <option key={sw.softwareId} value={sw.softwareId}>
        {sw.softwareName}
      </option>
    ))}
  </select>
</div>
          {/* Upload box */}
          <div className="form-group upload-group">
            <label>फोटो अपलोड करा</label>
            <div className="upload-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
                <path d="M19.1673 31.6615H10.834C8.75482 31.6615 6.9851 30.936 5.52482 29.4852C4.06426 28.0344 3.33398 26.2694 3.33398 24.1902C3.33398 22.2799 3.98676 20.5845 5.29232 19.104C6.59787 17.6231 8.22079 16.8281 10.1611 16.719C10.535 14.2917 11.6513 12.2865 13.5102 10.7031C15.3691 9.11979 17.5326 8.32812 20.0007 8.32812C22.7806 8.32812 25.1423 9.29979 27.0856 11.2431C29.029 13.1865 30.0006 15.5481 30.0006 18.3281V19.9948H31.0265C32.6226 20.0462 33.9618 20.6322 35.044 21.7527C36.1262 22.8735 36.6673 24.232 36.6673 25.8281C36.6673 27.4628 36.1037 28.8437 34.9765 29.9706C33.8495 31.0978 32.4687 31.6615 30.834 31.6615H20.834V19.296L24.334 22.7769L25.5136 21.6294L20.0007 16.1165L14.4877 21.6294L15.6673 22.7769L19.1673 19.296V31.6615Z" fill="#2563EB" />
              </svg>
               <input
              type="file"
              onChange={(e) => setProfilePicture(e.target.files[0])}
            />
              <p>
                <span>अपलोड करण्यासाठी क्लिक करा</span> किंवा फाइल ओढून सोडा
                <br />
                <small>एसव्हीजी, पीएनजी, जेपीजी किंवा जीआयएफ (कमाल आकार: ८००x४०० पिक्सेल)</small>
              </p>
            </div>
          </div>
        </form>
      </div>
      {/* SUCCESS POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#FFFFFF"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" /></svg>
            </div>

            <h3>विद्यार्थी यशस्वीरित्या जोडले गेले आहेत. !</h3>
            <p>
              विद्यार्थ्याची नोंदणी यशस्वीरित्या पूर्ण झाली आहे.
              <br />खालील त्याचा विद्यार्थी ID दिला आहे.
            </p>

         <div className="student-id">
  विद्यार्थी ID: <b>{createdStudent?.studentUniqueId}</b>
</div>



            <button
              className="popup-btn"
              onClick={() => {
                setShowPopup(false);
                navigate(-1); // optional: back to list
              }}
            >
              ठीक आहे
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddStudent;

